import ConektaVoucher from './vouchers/ConektaVoucher';
import PaycashVoucher from './vouchers/PaycashVoucher';

/**
 * Registry of store-payment vouchers keyed by payment engine.
 * Adding a new engine's ficha is a single entry here plus its voucher component — no new branching
 * elsewhere. Mirrors frontline-platform's `purchases/#{engine}_payment_format` template lookup.
 */
const VOUCHERS = {
  conekta: ConektaVoucher, // OXXO (OXXOPay)
  paycash: PaycashVoucher,
};

/**
 * Resolve the engine key from a payment engine string, mirroring frontline's `File.basename`
 * (engine values may be namespaced, e.g. `kushki/store`).
 *
 * @param {string} [paymentEngine] - The payment engine from the payment payload.
 * @returns {string} The normalized engine key (last path segment), or '' when absent.
 */
export function engineKey(paymentEngine) {
  if (!paymentEngine) return '';
  const segments = String(paymentEngine).split('/');
  return segments[segments.length - 1];
}

/**
 * Whether a voucher component exists for the given payment engine.
 *
 * @param {string} [paymentEngine] - The payment engine from the payment payload.
 * @returns {boolean} True when a voucher is registered for the engine.
 */
export function hasVoucherForEngine(paymentEngine) {
  return Boolean(VOUCHERS[engineKey(paymentEngine)]);
}

/**
 * The voucher component for the given payment engine, or null when none is registered.
 *
 * @param {string} [paymentEngine] - The payment engine from the payment payload.
 * @returns {React.ComponentType|null} The voucher component or null.
 */
export function getVoucherForEngine(paymentEngine) {
  return VOUCHERS[engineKey(paymentEngine)] || null;
}

export default VOUCHERS;
